export default __webpack_public_path__ + "static/media/008-pirate-2.328b7fd8.png";